import { render, staticRenderFns } from "./approve-creatives-warning-modal.vue?vue&type=template&id=2debc6ae&scoped=true"
import script from "./approve-creatives-warning-modal.vue?vue&type=script&lang=js"
export * from "./approve-creatives-warning-modal.vue?vue&type=script&lang=js"
import style0 from "./approve-creatives-warning-modal.vue?vue&type=style&index=0&id=2debc6ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2debc6ae",
  null
  
)

export default component.exports